<template>
  <div class="mb-3 mt-3 ">
    <b-container v-if="status == 'OK'">
      <div class="alert text-white bg-light-primary text-center" >
        پرداخت با موفقیت انجام شد
      </div>

      <table-items class="bg-white" :item="basketInfo.transaction"/>
    </b-container>
    <b-container v-else>
      <div class="alert alert-danger text-center" role="alert">
        عملیات پرداخت ناموفق بود
      </div>
    </b-container>
    <b-container class="text-left ">
      <router-link :to="{ name: 'UserOrders' }">
        <b-button pill variant="primary">مشاهده وضعیت سفارش</b-button>
      </router-link>
    </b-container>
  </div>
</template>
<script>
import router from "@/router";
import tableItems from "../ShoppingCards/ShoppingCard1/tableItems";
import {mapGetters} from "vuex";

export default {
  name: "VerifyTransaction",
  components: {tableItems},
  computed: {
    status() {
      return router.currentRoute.query.Status;
    },
    ...mapGetters({
      basketInfo: "ShoppingCart/getUserOrderPaidItems",
    }),
  },
  mounted() {
    const order = router.currentRoute.params.order;
    const user = router.currentRoute.params.user;
    const Authority = router.currentRoute.query.Authority;
    const status = router.currentRoute.query.Status;
    let form = {order: order, user: user, Authority: Authority};
    this.$store.dispatch("Transaction/verifyTransaction", form);
  },
};
</script>
<style scoped>

.bg-light-primary {
  background: var(--light-primary) !important;
}

</style>